import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d54797c8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d54797c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54797c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d54797c8')) {
      api.createRecord('d54797c8', component.options)
    } else {
      api.reload('d54797c8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d54797c8&scoped=true&", function () {
      api.rerender('d54797c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/keyword-search/modules/addConfig/index.vue"
export default component.exports